import styled from 'styled-components';
import { Button, TableList, Loader } from '@ederzadravec/jade-ui';

import { Text, ButtonDelete } from 'components';
import { useService } from 'service';
import Viewer from '../viewers/viewer/Viewer';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  width: inherit;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Content = styled.div`
  width: 100%;
  margin-top: 16px;
`;

const LinkAction = styled(Text)`
  margin-right: 8px;
`;

export default ({ history }) => {
  const [awardsData, { loading }, refreshAwards] = useService('get', '/award?limit=1000');

  const BASE_URL = '/admin/award';

  const configList = [
    {
      name: 'P/ Usuário',
      dataPath: data => data.viewer.name,
      size: {
        md: 3,
      },
    },

    {
      name: 'Prêmio',
      dataPath: 'award',
      size: {
        md: 3,
      },
    },

    {
      name: 'Prêmio',
      dataPath: 'description',
      size: {
        md: 3,
      },
    },
    {
      name: 'Ações',
      dataPath: data => {
        return (
          <>
            <LinkAction type="link" bold onClick={() => history.push(`${BASE_URL}/${data._id}`)}>
              Editar
            </LinkAction>

            <ButtonDelete refresh={refreshAwards} name={data.award} route={`/award/${data._id}`} />
          </>
        );
      },
      size: {
        md: 3,
      },
    },
  ];

  return (
    <Container>
      <Header>
        <Text type="h3" size="24" bold color="black">
          Prêmios
        </Text>

        <Button
          onClick={() => {
            history.push(`${BASE_URL}/new`);
          }}>
          Novo
        </Button>
      </Header>

      <Loader show={loading}>
        <Content>
          <TableList config={configList} data={awardsData?.success?.awards?.data || []} />
        </Content>
      </Loader>
    </Container>
  );
};
